var map = {
	"./BW_film_photography.jpg": 20623,
	"./alternative_processes.jpg": 33485,
	"./color_film_photography.jpg": 64582,
	"./ikebana.jpg": 83998,
	"./in_relation_to_series.jpg": 17290,
	"./installation_performance.jpg": 4247,
	"./nightscapes.jpg": 58522,
	"./photographic_relationships_collaboration.jpg": 98429,
	"./printmaking_doodles_and_painting.jpg": 79135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14965;